import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHome, FaFolder, FaChartLine, FaRegFileAlt, FaUsers, FaClipboardList, FaProjectDiagram, FaSignOutAlt, FaBars } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { FaUserPen } from "react-icons/fa6";
import logo from "../../../assets/logo-IRC.png";
import "./AdminSidebar.css";
import { logout } from "../../../auth/Logout";

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const closeOnNavigate = () => setIsOpen(false);
  const toggleSidebar = () => setIsOpen((v) => !v);

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="sidebar-toggle"
        aria-label="Ouvrir le menu"
        onClick={toggleSidebar}
      >
        <FaBars />
      </button>

      {/* Sidebar overlay for mobile */}
      {isOpen && <div className="sidebar-backdrop" onClick={closeOnNavigate} />}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="logo-container">
          <img src={logo} alt="IRC Logo" className="logo" />
        </div>
      <Link to="/home" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/home") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaHome style={{ marginRight: "8px" }} />
          Accueil
        </div>
      </Link>
      <Link to="/admin-projet" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/admin-projet") || isActive("/AjouteruneComp") || isActive("/ModifierComp") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaFolder style={{ marginRight: "8px" }} />
          Compétitions
        </div>
      </Link>
      <Link to="/Project_Soumissione" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/Project_Soumissione") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaProjectDiagram style={{ marginRight: "8px" }} />
          Projets
        </div>
      </Link>
      <Link to="/Utilisateurs" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/Utilisateurs") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FiUsers style={{ marginRight: "8px" }} />
          Utilisateurs
        </div>
      </Link>
      <Link to="/comite" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/comite") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaUsers style={{ marginRight: "8px" }} />
          Comité
        </div>
      </Link>
      <Link to="/AdminDocument" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/AdminDocument") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaRegFileAlt style={{ marginRight: "8px" }} />
          Documents
        </div>
      </Link>
      <Link to="/admin-evaluation-grid-list" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/admin-evaluation-grid-list") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaClipboardList style={{ marginRight: "8px" }} />
          Grille d'évaluation
        </div>
      </Link>
      <Link to="/parametre" style={{ textDecoration: "none" }}>
        <div className={`sidebar-item ${isActive("/parametre") ? "active" : ""}`} onClick={closeOnNavigate}>
          <FaChartLine className="sidebar-icon" /> Budget
        </div>
      </Link>
      <div className="sidebar-item" style={{ cursor: "pointer" }} onClick={() => { logout(navigate); closeOnNavigate(); }}>
        <FaSignOutAlt style={{ marginRight: "8px" }} />
        Se déconnecter
      </div>
      </div>
    </>
  );
};

export default AdminSidebar;